export default __webpack_public_path__ + "static/_02_Climate-Neutral-630c60942f1ea37a1ef96c01434cce0b.svg";